const subscribeToBrevo = async (email) => {
  const response = await fetch("https://api.brevo.com/v3/contacts", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "api-key": process.env.REACT_APP_BREVO_API_KEY,
    },
    body: JSON.stringify({
      email,
      listIds: [2],
      updateEnabled: true,
    }),
  });

  const data =
    response.status === 204
      ? {}
      : await response.json();

  if (!response.ok) {
    throw new Error(
      data.message || "Unable to subscribe."
    );
  }

  return data;
};

export default subscribeToBrevo;